export const attendee = {
    forms: (slug: string): string => `/rooms/${slug}/forms/`,
    formDetails: (slug: string, formId: string): string => `/rooms/${slug}/forms/${formId}/`
};

export const admin = {
    forms: (slug: string): string => `/administrator/rooms/${slug}/forms/`,
    formDetails: (slug: string, formId: string): string =>
        `/administrator/rooms/${slug}/forms/${formId}/`
};

export const api = {
    createFormShortLink: (formId: string) => `/api/forms/${formId}/short_link/`,
    downloadFormXlsx: (formId: string) => `/api/forms/${formId}/download_xlsx/`,
    form: (formId: string) => `/api/forms/${formId}/`,
    forms: () => '/api/forms/',
    formTemplates: () => '/api/form_templates/',
    formSubmit: (formId: string) => `/api/forms/${formId}/submit/`
};
